import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card, Container, Row, Col, Table, Form, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { triggerBase64Download } from "common-base64-downloader-react";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import Footer from "../../UI/Footer";
import { getAttendanceMonthly, getAttendanceExcelMonth, updateSearchDetails, resetDetails } from "./AttendanceMonthlySlice";
import { useNavigate } from "react-router-dom";

function AttendanceMonthlyComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { searchDetails, employeeLists } = useSelector((state) => state.AttendanceMonthlySlice);
  const { month, year, start_time, end_time, time, sort } = searchDetails;
  const [timeBetween, setTimeBetween] = useState(true);
  const [timeInputs, setTimeInputs] = useState({
    startHour: "08",
    startMinute: "30",
    startSecond: "00",
    endHour: "08",
    endMinute: "45",
    endSecond: "00",
  });

  const betweenAfter = [
    { value: "AFTER", label: "AFTER" },
    { value: "BETWEEN", label: "BETWEEN" }
  ];

  const sortOptions = [
    { value: "DEPARTMENT", label: "DEPARTMENT" },
    { value: "HIGHEST", label: "HIGHEST" }
  ];

  // Define options for month and year
  const monthOptions = [
    { value: 1, label: "JANUARY" },
    { value: 2, label: "FEBRUARY" },
    { value: 3, label: "MARCH" },
    { value: 4, label: "APRIL" },
    { value: 5, label: "MAY" },
    { value: 6, label: "JUNE" },
    { value: 7, label: "JULY" },
    { value: 8, label: "AUGUST" },
    { value: 9, label: "SEPTEMBER" },
    { value: 10, label: "OCTOBER" },
    { value: 11, label: "NOVEMBER" },
    { value: 12, label: "DECEMBER" },
  ];

  const yearOptions = [
    { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
    { value: new Date().getFullYear(), label: new Date().getFullYear() },
    { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 }
  ];

  useEffect(() => {

    const initializeSearchDetails = () => {
      const startTime = `${timeInputs.startHour}:${timeInputs.startMinute}:${timeInputs.startSecond}`;
      const endTime = `${timeInputs.endHour}:${timeInputs.endMinute}:${timeInputs.endSecond}`;

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      const initialDetails = { ...searchDetails, 
        month: currentMonth,
        year: currentYear, 
        start_time: startTime,
        end_time: endTime,
        time: "BETWEEN",
        sort: "DEPARTMENT"
      };
      console.log(initialDetails)
      dispatch(updateSearchDetails(initialDetails));
    };

    initializeSearchDetails();
  }, []);

  const handleMonthChange = (selectedOption) => {
    const entity = { ...searchDetails, month: selectedOption.value }; // Access label directly
    console.log(entity);
    dispatch(updateSearchDetails(entity));
  };

  const handleYearChange = (selectedOption) => {
    const entity = { ...searchDetails, year: selectedOption.value }; // Access label directly
    console.log(entity);
    dispatch(updateSearchDetails(entity));
  };

  const handleTimeChange = (selectedOption) => {
    if (selectedOption.value === "BETWEEN") {
      setTimeBetween(true);
    }
    else {
      setTimeBetween(false);
    }
    const entity = { ...searchDetails, time: selectedOption.value }; // Access label directly
    console.log(entity);
    dispatch(updateSearchDetails(entity));
  };

  const handleSortChange = (selectedOption) => {
    const entity = { ...searchDetails, sort: selectedOption.value }; // Access label directly
    console.log(entity);
    dispatch(updateSearchDetails(entity));
  };

  const handleTimeInputChange = (e) => {
    const { name, value } = e.target;
    // setTimeInputs((prev) => ({ ...prev, [name]: value }));
    // Allow only numeric input and restrict length to 2 digits
    if (/^\d{0,2}$/.test(value)) {
      setTimeInputs((prevState) => ({
          ...prevState,
          [name]: value,
      }));
    }
  };

  const updateCombinedTime = (name) => {
    const combinedTime = `${timeInputs[`${name}Hour`]}:${timeInputs[`${name}Minute`]}:${timeInputs[`${name}Second`]}`;
    const entity = { ...searchDetails, [`${name}_time`]: combinedTime };
    console.log(entity)
    dispatch(updateSearchDetails(entity));
  };

  const handleClickSearch = () => {
    // Validate required fields
    if (!month || !year || !start_time || !end_time) {
      alert("Please fill out all fields.");
      return; // Exit if validation fails
    }

    dispatch(getAttendanceMonthly(searchDetails));
  };

  const handleBack = () => {
    dispatch(resetDetails());
    navigate(-1);
  };

  const handleExportExcel = () => {
    // Dispatch the action to fetch the Excel data
    dispatch(getAttendanceExcelMonth({employeeLists, month, year, start_time, end_time, time})).then((res) => {
      console.log(res);
      console.log(res.payload);
      
      // Create the base64 string for the Excel file
      const base64EXCEL =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        res.payload.file;
      
      // Trigger the download of the Excel file
      triggerBase64Download(
        base64EXCEL,
        "AttendanceLists_For_" + month
      );
    });
  };
  
  return (
    <div className="Div">
      <Container fluid>
        <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
        <Row>
          <Col
            xs={2}
            id="sidebar-wrapper"
            className="sidemenu"
            style={{ marginTop: "50px" }}
          >
            <SideMenu />
          </Col>
          <Col>
            <Card className="content">
              <Form>
                <Container fluid>
                  <Row className="mb-3 mt-3">
                    <Col md={12}>
                      <h4>MONTHLY ATTENDANCE REPORT</h4>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label>MONTH:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Select
                        onChange={handleMonthChange}
                        options={monthOptions}
                        value={monthOptions.find((option) => option.value === month)}
                        placeholder="Select Month"
                      />
                    </Col>
                    <Col md={3}>
                      <Form.Label>YEAR:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Select
                        onChange={handleYearChange}
                        options={yearOptions}
                        value={yearOptions.find((option) => option.value === year)}
                        placeholder="Select Year"
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3 d-flex align-items-center">
                    <Col md={3}>
                      <Form.Label>SORT BY:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Select
                        onChange={handleSortChange}
                        options={sortOptions}
                        value={sortOptions.find((option) => option.value === sort)}
                        placeholder="Select Sort"
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3 d-flex align-items-center">
                    <Col md={3}>
                      <Form.Label>TIME:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Select
                        onChange={handleTimeChange}
                        options={betweenAfter}
                        value={betweenAfter.find((option) => option.value === time)}
                        placeholder="Select Between or After"
                      />
                    </Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label></Form.Label>
                    </Col>
                    <Col md={3} className="d-flex align-items-center">
                      <Form.Control
                        type="text"
                        name="startHour"
                        placeholder="HH"
                        value={timeInputs.startHour}
                        onChange={handleTimeInputChange}
                        onBlur={() => updateCombinedTime("start")}
                        style={{ width: "4rem", textAlign: "center" }}
                      />&nbsp;&nbsp; : &nbsp;&nbsp;
                      <Form.Control
                        type="text"
                        name="startMinute"
                        placeholder="MM"
                        value={timeInputs.startMinute}
                        onChange={handleTimeInputChange}
                        onBlur={() => updateCombinedTime("start")}
                        style={{ width: "4rem", textAlign: "center" }}
                      />&nbsp;&nbsp; : &nbsp;&nbsp;
                      <Form.Control
                        type="text"
                        name="startSecond"
                        placeholder="SS"
                        value={timeInputs.startSecond}
                        onChange={handleTimeInputChange}
                        onBlur={() => updateCombinedTime("start")}
                        style={{ width: "4rem", textAlign: "center" }}
                      />
                    </Col>
                    {timeBetween && (
                      <>
                      <Col md={3}>
                        <Form.Label>AND</Form.Label>
                      </Col>
                      <Col md={3} className="d-flex align-items-center">
                        <Form.Control
                          type="text"
                          name="endHour"
                          placeholder="HH"
                          value={timeInputs.endHour}
                          onChange={handleTimeInputChange}
                          onBlur={() => updateCombinedTime("end")}
                          style={{ width: "4rem", textAlign: "center" }}
                        />&nbsp;&nbsp; : &nbsp;&nbsp;
                        <Form.Control
                          type="text"
                          name="endMinute"
                          placeholder="MM"
                          value={timeInputs.endMinute}
                          onChange={handleTimeInputChange}
                          onBlur={() => updateCombinedTime("end")}
                          style={{ width: "4rem", textAlign: "center" }}
                        />&nbsp;&nbsp; : &nbsp;&nbsp;
                        <Form.Control
                          type="text"
                          name="endSecond"
                          placeholder="SS"
                          value={timeInputs.endSecond}
                          onChange={handleTimeInputChange}
                          onBlur={() => updateCombinedTime("end")}
                          style={{ width: "4rem", textAlign: "center" }}
                        />
                      </Col>
                      </>
                    )}
                  </Row>

                  <Row className="justify-content-md-center mb-3">
                    <Col xs="auto" md={12}>
                      <Form.Group>
                        <Button
                          type="button"
                          bg="dark"
                          variant="dark"
                          onClick={handleClickSearch}
                        >
                          SEARCH
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Card className="border-0">
                    <Table bordered responsive className="table-sm" style={{ fontSize: "13px" }}>
                      <thead>
                        <tr className="tableheader">
                          <th className="text-center" colSpan="3" style={{ width: "30px" }}></th> {/* Empty cells for Name and Department */}
                          {Array.from({ length: 31 }, (_, i) => {
                            const dayOfWeek = ["S", "M", "T", "W", "T", "F", "S"][new Date(year, month - 1, i + 1).getDay()];
                            return (
                              <th key={i} className="text-center">{dayOfWeek}</th>
                            );
                          })}
                          <th className="text-center"></th> {/* Empty cell for Total */}
                        </tr>

                        <tr className="tableheader">
                          <th className="text-start">Name</th>
                          <th className="text-start">Department</th>
                          <th className="text-center">M</th>
                          {Array.from({ length: 31 }, (_, i) => (
                            // <th key={i} className="text-center">{`D${String(i + 1).padStart(2, '0')}`}</th>
                            <th key={i} className="text-center" style={{ width: "30px" }}>{i + 1}</th>
                          ))}
                          <th className="text-center">T</th>
                        </tr>
                      </thead>
                      <tbody>
                        {employeeLists && employeeLists.length > 0 ? (
                          employeeLists.map((employee, index) => (
                            <tr key={index}>
                              <td className="text-start fw-bold">{employee.person_fullname}</td>
                              <td className="text-start fw-bold">{employee.department_description.toUpperCase()}</td>
                              <td className="text-center">{employee.is_manager}</td>
                              {Array.from({ length: 31 }, (_, i) => (
                                <td key={i} className="text-center">{employee[`d${String(i + 1).padStart(2, '0')}`]}</td>
                                // <td key={i} className="text-center">{employee[`d01`]}</td>
                              ))}
                              <td className="text-center fw-bold">{employee.total}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="35" className="text-center">No data available</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Card>
                  <Row className="mb-3 mt-3">
                    <Col md={1}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={handleBack}
                      >
                        Back
                      </Button>
                    </Col>
                    <Col md={9}></Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={() => handleExportExcel()}
                      >
                        Download
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default AttendanceMonthlyComponent;